import addExamTemplate from './addExamPopup.htm';
import addMarksTemplate from './addMarksPopup.htm';
import addStudentTemplate from './addStudentPopup.htm';
import R from 'ramda';

export default function IndvClassController($stateParams, $scope, $state, localStorageService, GetService, $mdDialog, ClassRoomService, StudentService, ExamService) {
  var self = this;
  $scope.open=false;
  $scope.isOpen = false;
  $scope.demo = {
    isOpen: false,
    count: 0,
    selectedDirection: 'right'
  };

  self.classObj = {};
  self.searchOpen=false;
  self.openSearch = function(){
    console.log(self.searchOpen);
    self.searchOpen=true;
  };

  self.classRoomName = $stateParams.classRoomName;
  self.subName = $stateParams.subName;
  var classId = $stateParams.cId;

  var classRoomList = localStorageService.get('classrooms');
  var classObj = {'updateStatus': 'addStudents'};
  for(var i=0;i<classRoomList.length; i++){
    if(classRoomList[i].classRoomId == classId && classRoomList[i].subjectName == self.subName){
      self.subjectId = classRoomList[i].subjectId;
      self.subjectName = classRoomList[i].subjectName;
      self.classRoomId = classRoomList[i].classRoomId;
    }
  }

  $scope.showAddStudents = false;

  this.getClassDetails = function(){
    ClassRoomService.getClassRoomDetails(self.classRoomId, self.subjectId).then(function(resp){
      if(resp.data.length > 0){
        console.log(resp.data);
        $scope.showAddStudents = false;
        self.newStudentArray = resp.data;
        self.classObj = {'className': self.classRoomName, 'strength': self.newStudentArray.length};
      }
      else{
        self.classObj = {'className': self.classRoomName, 'strength': 0};
        $scope.showAddStudents = true;
      }
    });
  };

  self.getClassDetails();

  // self.getClassDetails = function(){
  //   ClassRoomService.getClassRoomDetails(self.classId, )
  // }

  // self.newStudentArray = [{'studentName' : 'John Doe', 'emailId': 'john.doe@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 74}, {'examName': 'Exam4', 'marks': 94}, {'examName': 'Exam5', 'marks': 79}]},
  //                      {'studentName' : 'Mike Hamilton', 'emailId': 'mike.Hamilton@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 82}, {'examName': 'Exam2', 'marks': 94}, {'examName': 'Exam3', 'marks': 28}, {'examName': 'Exam4', 'marks': 58}, {'examName': 'Exam5', 'marks': 49}]},
  //                      {'studentName' : 'George Aldo', 'emailId': 'george.aldo@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 33}, {'examName': 'Exam2', 'marks': 84}, {'examName': 'Exam3', 'marks': 82}, {'examName': 'Exam4', 'marks': 68}, {'examName': 'Exam5', 'marks': 90}]},
  //                      {'studentName' : 'Ami Jackson', 'emailId': 'ami.jackson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 72}, {'examName': 'Exam2', 'marks': 95}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 40}, {'examName': 'Exam5', 'marks': 87}]},
  //                      {'studentName' : 'Sai Sridhar Dasari', 'emailId': 'sai.sridhardasari@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 85}, {'examName': 'Exam2', 'marks': 78}, {'examName': 'Exam3', 'marks': 49}, {'examName': 'Exam4', 'marks': 39}, {'examName': 'Exam5', 'marks': 99}]},
  //                      {'studentName' : 'Chris McDonalds', 'emailId': 'chris.mcdonals@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 44}, {'examName': 'Exam2', 'marks': 73}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 93}, {'examName': 'Exam5', 'marks': 88}]},
  //                      {'studentName' : 'Kevin Peterson', 'emailId': 'kevin.peterson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 0}, {'examName': 'Exam2', 'marks': 83}, {'examName': 'Exam3', 'marks': 34}, {'examName': 'Exam4', 'marks': 92}, {'examName': 'Exam5', 'marks': 79}]},
  //                      {'studentName' : 'Ricky Pointing', 'emailId': 'ricky.pointing@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 28}, {'examName': 'Exam2', 'marks': 97}, {'examName': 'Exam3', 'marks': 39}, {'examName': 'Exam4', 'marks': 18}, {'examName': 'Exam5', 'marks': 80}]},
  //                      {'studentName' : 'Adam Gilchrist', 'emailId': 'adam.dilly@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 49}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 47}, {'examName': 'Exam4', 'marks': 58}, {'examName': 'Exam5', 'marks': 86}]},
  //                      {'studentName' : 'Christian Ronaldino', 'emailId': 'christian.ronaldino@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 100}, {'examName': 'Exam2', 'marks': 84}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 78}, {'examName': 'Exam5', 'marks': 74}]},
  //                      {'studentName' : 'Stone Cold', 'emailId': 'stone.cold@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 39}, {'examName': 'Exam2', 'marks': 88}, {'examName': 'Exam3', 'marks': 77}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 71}]},
  //                      {'studentName' : 'Mark Mikael', 'emailId': 'Mark Mikael.doe@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 42}, {'examName': 'Exam2', 'marks': 89}, {'examName': 'Exam3', 'marks': 55}, {'examName': 'Exam4', 'marks': 48}, {'examName': 'Exam5', 'marks': 81}]},
  //                      {'studentName' : 'Sai Sridhar Mullapudi', 'emailId': 'saisridhar.mullapudi@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 82}, {'examName': 'Exam2', 'marks': 74}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 38}, {'examName': 'Exam5', 'marks': 43}]},
  //                      {'studentName' : 'Mark Zuckerburg', 'emailId': 'mark.zuckerburg@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 32}, {'examName': 'Exam2', 'marks': 85}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 100}, {'examName': 'Exam5', 'marks': 86}]},
  //                      {'studentName' : 'Jesica Andrew', 'emailId': 'jesica.andrew@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 56}, {'examName': 'Exam2', 'marks': 10}, {'examName': 'Exam3', 'marks': 45}, {'examName': 'Exam4', 'marks': 100}, {'examName': 'Exam5', 'marks': 19}]},
  //                      {'studentName' : 'Deepak Chandu Mokkapati', 'emailId': 'deepakchandu.mokkapati@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 73}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 40}]},
  //                      {'studentName' : 'Christopher M', 'emailId': 'christopher.m@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 40}, {'examName': 'Exam2', 'marks': 94}, {'examName': 'Exam3', 'marks': 100}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 50}]},
  //                      {'studentName' : 'Bizmark Peterson', 'emailId': 'bizmark.peterson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 72}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 94}, {'examName': 'Exam4', 'marks': 38}, {'examName': 'Exam5', 'marks': 70}]},
  //                      {'studentName' : 'David Drewpaul', 'emailId': 'david.Drewpaul@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 62}, {'examName': 'Exam2', 'marks': 88}, {'examName': 'Exam3', 'marks': 10}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 50}]},
  //                      {'studentName' : 'Kelly Johnson', 'emailId': 'kelly.johnson@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 90}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 90}, {'examName': 'Exam4', 'marks': 33}, {'examName': 'Exam5', 'marks': 93}]},
  //                      {'studentName' : 'Deepika Gannamaneni', 'emailId': 'deepika.gannamaneni@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 100}, {'examName': 'Exam3', 'marks': 59}, {'examName': 'Exam4', 'marks': 67}, {'examName': 'Exam5', 'marks': 29}]},
  //                      {'studentName' : 'Chris Gayle', 'emailId': 'chris.gayle@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 23}, {'examName': 'Exam2', 'marks': 42}, {'examName': 'Exam3', 'marks': 94}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 85}]},
  //                      {'studentName' : 'Bravo Donald', 'emailId': 'bravo.donald@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 9}, {'examName': 'Exam2', 'marks': 92}, {'examName': 'Exam3', 'marks': 84}, {'examName': 'Exam4', 'marks': 87}, {'examName': 'Exam5', 'marks': 49}]},
  //                      {'studentName' : 'Captain America', 'emailId': 'captain.america@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 39}, {'examName': 'Exam2', 'marks': 100}, {'examName': 'Exam3', 'marks': 39}, {'examName': 'Exam4', 'marks': 39}, {'examName': 'Exam5', 'marks': 90}]},
  //                      {'studentName' : 'Bernard Hunk', 'emailId': 'bernard.hunk@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 69}, {'examName': 'Exam2', 'marks': 42}, {'examName': 'Exam3', 'marks': 58}, {'examName': 'Exam4', 'marks': 55}, {'examName': 'Exam5', 'marks': 83}]},
  //                      {'studentName' : 'Glen wood', 'emailId': 'glen.wood@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 28}, {'examName': 'Exam2', 'marks': 95}, {'examName': 'Exam3', 'marks': 97}, {'examName': 'Exam4', 'marks': 94}, {'examName': 'Exam5', 'marks': 91}]},
  //                      {'studentName' : 'Brian Saknovsky', 'emailId': 'brian.saknovsky@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 45}, {'examName': 'Exam2', 'marks': 52}, {'examName': 'Exam3', 'marks': 37}, {'examName': 'Exam4', 'marks': 73}, {'examName': 'Exam5', 'marks': 100}]},
  //                      {'studentName' : 'Allen Peter', 'emailId': 'allen.peter@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 66}, {'examName': 'Exam2', 'marks': 49}, {'examName': 'Exam3', 'marks': 83}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 100}]},
  //                      {'studentName' : 'John Doe 2', 'emailId': 'john.doe2@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 99}, {'examName': 'Exam2', 'marks': 39}, {'examName': 'Exam3', 'marks': 23}, {'examName': 'Exam4', 'marks': 99}, {'examName': 'Exam5', 'marks': 94}]},
  //                      {'studentName' : 'Koushik Yenugula', 'emailId': 'koushik.yenugula@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 86}, {'examName': 'Exam2', 'marks': 19}, {'examName': 'Exam3', 'marks': 0}, {'examName': 'Exam4', 'marks': 95}, {'examName': 'Exam5', 'marks': 34}]},
  //                      {'studentName' : 'Prince portor', 'emailId': 'prince.portor@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 21}, {'examName': 'Exam2', 'marks': 46}, {'examName': 'Exam3', 'marks': 44}, {'examName': 'Exam4', 'marks': 97}, {'examName': 'Exam5', 'marks': 2}]},
  //                      {'studentName' : 'Jack Lauremen', 'emailId': 'jack.lauremen@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 2}, {'examName': 'Exam2', 'marks': 85}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 29}, {'examName': 'Exam5', 'marks': 93}]},
  //                      {'studentName' : 'Barack Obama', 'emailId': 'barack.obama@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 67}, {'examName': 'Exam2', 'marks': 90}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 44}, {'examName': 'Exam5', 'marks': 81}]},
  //                      {'studentName' : 'John F Kennedy', 'emailId': 'john.kennedy@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 46}, {'examName': 'Exam2', 'marks': 52}, {'examName': 'Exam3', 'marks': 44}, {'examName': 'Exam4', 'marks': 66}, {'examName': 'Exam5', 'marks': 86}]},
  //                      {'studentName' : 'Alexander Vanter', 'emailId': 'alexander.vanter@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 38}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 82}, {'examName': 'Exam5', 'marks': 46}]},
  //                      {'studentName' : 'Abraham Lincoln', 'emailId': 'abraham.lincoln@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 39}, {'examName': 'Exam2', 'marks': 100}, {'examName': 'Exam3', 'marks': 47}, {'examName': 'Exam4', 'marks': 20}, {'examName': 'Exam5', 'marks': 90}]},
  //                      {'studentName' : 'Steve Jobs', 'emailId': 'steve.jobs@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 92}, {'examName': 'Exam2', 'marks': 49}, {'examName': 'Exam3', 'marks': 48}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 83}]},
  //                      {'studentName' : 'Lisa fernendez', 'emailId': 'lisa.fernendez@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 40}, {'examName': 'Exam2', 'marks': 49}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 40}, {'examName': 'Exam5', 'marks': 99}]},
  //                      {'studentName' : 'Madona morney', 'emailId': 'madona.morney@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 20}, {'examName': 'Exam2', 'marks': 33}, {'examName': 'Exam3', 'marks': 39}, {'examName': 'Exam4', 'marks': 70}, {'examName': 'Exam5', 'marks': 91}]},
  //                      {'studentName' : 'Adolf Mitchel Doe', 'emailId': 'adolf.mitchel@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 30}, {'examName': 'Exam2', 'marks': 19}, {'examName': 'Exam3', 'marks': 22}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 44}]},
  //                      {'studentName' : 'George Goula', 'emailId': 'george.goula@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 50}, {'examName': 'Exam2', 'marks': 93}, {'examName': 'Exam3', 'marks': 94}, {'examName': 'Exam4', 'marks': 84}, {'examName': 'Exam5', 'marks': 94}]},
  //                      {'studentName' : 'John Grisham', 'emailId': 'john.grisham@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 44}, {'examName': 'Exam2', 'marks': 93}, {'examName': 'Exam3', 'marks': 59}, {'examName': 'Exam4', 'marks': 100}, {'examName': 'Exam5', 'marks': 93}]},
  //                      {'studentName' : 'Alex Mandervano', 'emailId': 'alex.mandervano@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 22}, {'examName': 'Exam2', 'marks': 97}, {'examName': 'Exam3', 'marks': 83}, {'examName': 'Exam4', 'marks': 44}, {'examName': 'Exam5', 'marks': 39}]},
  //                      {'studentName' : 'Eleanor Breslin', 'emailId': 'eleanor.breslin@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 3}, {'examName': 'Exam2', 'marks': 98}, {'examName': 'Exam3', 'marks': 82}, {'examName': 'Exam4', 'marks': 66}, {'examName': 'Exam5', 'marks': 100}]},
  //                      {'studentName' : 'Donald Trump', 'emailId': 'donald.trump@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 19}, {'examName': 'Exam2', 'marks': 0}, {'examName': 'Exam3', 'marks': 75}, {'examName': 'Exam4', 'marks': 93}, {'examName': 'Exam5', 'marks': 44}]},
  //                      {'studentName' : 'Shailendar Singh', 'emailId': 'shailendar.singh@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 43}, {'examName': 'Exam2', 'marks': 32}, {'examName': 'Exam3', 'marks': 85}, {'examName': 'Exam4', 'marks': 65}, {'examName': 'Exam5', 'marks': 99}]},
  //                      {'studentName' : 'Cris Cross G', 'emailId': 'criss.cross@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 44}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 44}, {'examName': 'Exam5', 'marks': 48}]},
  //                      {'studentName' : 'Margaret Miner', 'emailId': 'margaret.minar@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 67}, {'examName': 'Exam2', 'marks': 99}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 66}, {'examName': 'Exam5', 'marks': 73}]},
  //                      {'studentName' : 'Nick Noel', 'emailId': 'nick.noel@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 71}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 99}, {'examName': 'Exam4', 'marks': 22}, {'examName': 'Exam5', 'marks': 46}]},
  //                      {'studentName' : 'Zuang Chao', 'emailId': 'zuang.chao@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 0}, {'examName': 'Exam2', 'marks': 4}, {'examName': 'Exam3', 'marks': 41}, {'examName': 'Exam4', 'marks': 58}, {'examName': 'Exam5', 'marks': 39}]},
  //                      {'studentName' : 'ling ling', 'emailId': 'ling.ling@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 17}, {'examName': 'Exam2', 'marks': 19}, {'examName': 'Exam3', 'marks': 71}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 3}]},
  //                      {'studentName' : 'Melissa Mathews', 'emailId': 'melissa.mathews@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 58}, {'examName': 'Exam2', 'marks': 44}, {'examName': 'Exam3', 'marks': 97}, {'examName': 'Exam4', 'marks': 78}, {'examName': 'Exam5', 'marks': 10}]},
  //                      {'studentName' : 'Laura Kaplan', 'emailId': 'laura.kaplan@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 23}, {'examName': 'Exam2', 'marks': 33}, {'examName': 'Exam3', 'marks': 29}, {'examName': 'Exam4', 'marks': 75}, {'examName': 'Exam5', 'marks': 34}]},
  //                      {'studentName' : 'Samuel Sammy Adams', 'emailId': 'samuel.s.adams@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 12}, {'examName': 'Exam2', 'marks': 16}, {'examName': 'Exam3', 'marks': 47}, {'examName': 'Exam4', 'marks': 80}, {'examName': 'Exam5', 'marks': 48}]},
  //                      {'studentName' : 'Dinesh Reddy Julakanti', 'emailId': 'dineshreddy.julkanti@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 99}, {'examName': 'Exam2', 'marks': 62}, {'examName': 'Exam3', 'marks': 81}, {'examName': 'Exam4', 'marks': 98}, {'examName': 'Exam5', 'marks': 50}]},
  //                      {'studentName' : 'Moore John Doe', 'emailId': 'moore.j.doe@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 49}, {'examName': 'Exam2', 'marks': 55}, {'examName': 'Exam3', 'marks': 49}, {'examName': 'Exam4', 'marks':36}, {'examName': 'Exam5', 'marks': 61}]},
  //                      {'studentName' : 'Hillary Clinton', 'emailId': 'hillary.clinton@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 100}, {'examName': 'Exam2', 'marks': 39}, {'examName': 'Exam3', 'marks': 58}, {'examName': 'Exam4', 'marks': 35}, {'examName': 'Exam5', 'marks': 36}]},
  //                      {'studentName' : 'Bill Gates', 'emailId': 'bill.gates@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 10}, {'examName': 'Exam2', 'marks': 33}, {'examName': 'Exam3', 'marks': 88}, {'examName': 'Exam4', 'marks': 63}, {'examName': 'Exam5', 'marks': 78}]},
  //                      {'studentName' : 'John mitchell', 'emailId': 'john.mitchell@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 59}, {'examName': 'Exam2', 'marks': 57}, {'examName': 'Exam3', 'marks': 58}, {'examName': 'Exam4', 'marks': 38}, {'examName': 'Exam5', 'marks': 53}]},
  //                      {'studentName' : 'Ajinkya Sangakkara', 'emailId': 'ajinkya.sangakkara@gmail.com', 'examDetails' : [{'examName': 'Exam1', 'marks': 59}, {'examName': 'Exam2', 'marks': 76}, {'examName': 'Exam3', 'marks': 93}, {'examName': 'Exam4', 'marks': 49}, {'examName': 'Exam5', 'marks': 84}]}
  //                       ];

  // var localStudentArray = self.studentArray;

  // self.examsArray = [];

  // var studArrayKeys = [];
  // for(var key in localStudentArray[0]){
  //   studArrayKeys.push(key);
  // }

  // studArrayKeys.splice(0, 2);
   
  // for(var i=0;i<studArrayKeys.length;i++){
  //   self.examsArray.push(GetService.getExamObjByName(studArrayKeys[i]));
  // }

  // $scope.sortType     = 'classRoomName'; // set the default sort type
  // $scope.sortReverse  = false;  // set the default sort order
  $scope.searchClass   = '';     // set the default search/filter term
  
  // create the list of Class Rooms(dummy)
  // $scope.classObj = [
  //   { classRoomName: 'Tenth-A1', subject: 'Mathematics', strength: 42 },
  //   { classRoomName: 'Eigth-B2', subject: 'English', strength: 54 },
  //   { classRoomName: 'SNE-1B', subject: 'Chemistry', strength: 37 },
  //   { classRoomName: 'Seventh-alpha', subject: 'Social', strength: 56 }
  // ];

  // $scope.editItem = function (stuIndex, examIndex) {
  //   $scope.editing = ""+stuIndex+examIndex;
  //   document.getElementById("edit-input").focus();
  // };

  // $scope.doneEditing = function (stuIndex, examIndex) {
  //   $scope.editing = ""+stuIndex;
  //   //dong some background ajax calling for persistence...
  //   console.log(self.studentArray);
  // };

  // self.sortTableOnClick = function(param){
  // 	$scope.sortType = param;
  // 	$scope.sortReverse = !$scope.sortReverse;
  // };

  function showAddExam(ev) {
    $mdDialog.show({
      template:addExamTemplate,
      controller: AddExamController
    }).finally(function() {
      //Do Nothing Here
    });
  }

  var AddExamController = function($scope, $mdDialog){
    $scope.exam = {examName: '', examDesc: '', totalMarks: ''};

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function() {
      var classObj = {'updateStatus': 'addExam'};
      classObj.classRoomId = self.classRoomId;
      classObj.subjectId = self.subjectId;
      classObj.examDetails = $scope.exam;

      ClassRoomService.updateClassRoom(classObj).then(function(resp){
        console.log(resp.data);
        self.getClassDetails();
      });

      //self.examsArray.push({'examName': $scope.exam.examName, 'examId': 'exam1skol3'});
      $mdDialog.hide();
    };
  };

  function showAddStudent(ev) {
  	$mdDialog.show({
  		template: addStudentTemplate,
  		controller: AddStudentController
  	}).finally(function(){
  		//Do Nothing Here
  	});
  }

  // StudentService.getAllStudents()

  // self.schoolStudentsLis

  var AddStudentController = function($scope, $mdDialog, $q){

    $scope.studentList = [{studentName: 'Dasari Sai Sridhar', studentId: 'saisridhar@gmail.com'},
                          {studentName: 'John Doe', studentId: 'john@gmail.com'}];

    $scope.querySearch   = querySearch;
    $scope.selectedStudentChange = selectedStudentChange;
    $scope.searchTextChange   = searchTextChange;
    $scope.simulateQuery = true;

    function querySearch (query) {
      var results = query ? $scope.studentList.filter( createFilterFor(query) ) : $scope.studentList,
        deferred;
      if ($scope.simulateQuery) {
        deferred = $q.defer();
        if(query){
          StudentService.getStudentsByChar(query).then(function(resp){
            results = resp.data;
            deferred.resolve( results );
          });
        }else{
          results = [];
          deferred.resolve(results);
          // StudentService.getAllStudents().then(function(resp){
          //   results = resp.data;
          //   deferred.resolve( results );
          // });
        }
        //$timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } 
      else {
        return results;
      }
    }

    function searchTextChange(text) {
      console.log('Text changed to ' + text);
    }

    function selectedStudentChange(item) {
      if(item){
        $scope.student.emailId = item.studentId;
        $scope.studentSelected = item;
        $scope.showStuExistErr = false;
        $scope.showSelectStudErr = false;
      }
      else{
        $scope.student.emailId = '';
        $scope.studentSelected = '';
      }
      console.log('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(stuObj) {
        return (stuObj.studentName.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }

    $scope.showStuExistErr = false;
    $scope.showSelectStudErr = false;

    $scope.student = {studentName: '', emailId: ''};
    $scope.addedStudentsList =[];

    $scope.addStudent = function(){
      if($scope.studentSelected){
        if(R.findIndex(R.propEq('studentId', $scope.studentSelected.studentId))($scope.addedStudentsList) > -1){
          $scope.showStuExistErr = true;
        }else{
          $scope.addedStudentsList.push($scope.studentSelected);
        }
      }
      else{
        $scope.showSelectStudErr = true;
      }
      $scope.student.emailId = '';
      $scope.searchText = '';
      $scope.selectedStudent = undefined;
      setTimeout(function(){
        angular.element('#auto_complete').find('input').focus();
      },0);
    };

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    $scope.saveDialog = function() {
      if($scope.addedStudentsList.length < 1){
        $scope.showSelectStudErr = true;
        return;
      }
      var classRoomList = localStorageService.get('classrooms');
      var classObj = {'updateStatus': 'addStudents'};

      classObj.subjectId = self.subjectId;
      classObj.subjectName = self.subjectName;
      classObj.classRoomId = self.classRoomId;
      classObj.studentArray = $scope.addedStudentsList;
      ClassRoomService.updateClassRoom(classObj).then(function(resp){
        console.log(resp.data);
        self.getClassDetails();
      });
      // self.newStudentArray.push({studentName: $scope.student.studentName, emailId: $scope.student.emailId});
      $mdDialog.hide();
    };
  };

  function showAddMarks(ev) {
  	$mdDialog.show({
      controller: addMarksController,
      template: addMarksTemplate,
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
  }

  var addMarksController = function($scope, $mdDialog){
    $scope.editing = "-1";

    var buildStudentArray = function(array){
      var returnArray=[];
      for(var i=0; i<array.length; i++){
        var details = {'studentId': array[i].studentId, 'studentName': array[i].studentName};
        for(var j=0;j<array[i].examDetails.length; j++){
          details[array[i].examDetails[j].examName] = array[i].examDetails[j].marks;
        }
        returnArray.push(details);
      }
      return returnArray;
    };

    $scope.examsArray = self.examsArray;

    $scope.studentArray = buildStudentArray(self.newStudentArray);
    console.log($scope.studentArray);

    //$scope.studentArray[0].examDetails[0].marks = 45;
  	//var parentExamsArray = self.examsArray;

    // $scope.getMarksByExam = function(examName, studentId){
    //   console.log(examName);
    //   console.log(studentId);
    //   var returnValue = "";
    //   for(var i=0; i<$scope.studentArray.length; i++){
    //     if($scope.studentArray[i].studentId == studentId){
    //       for(var j=0; j<$scope.studentArray[i].examDetais.length; j++){
    //         if($scope.studentArray[i].examDetais[j].examName == examName){
    //           returnValue = $scope.studentArray[i].examDetais[j].marks;
    //         }
    //       }
    //     }
    //   }
    //   if(!returnValue){
    //     returnValue = "-";
    //   }
    //   return returnValue;
    // };

  	$scope.sortType     = 'studentName'; // set the default sort type
  	$scope.sortReverse  = false;  // set the default sort order
  	$scope.searchClass   = '';     // set the default search/filter term

  	//$scope.newStudentArray = self.newStudentArray;
  	//$scope.examsArray = parentExamsArray;
    self.editedItemsArray = [];
  	$scope.editItem = function (stuIndex, student, exam) {
      $scope.editing = ""+stuIndex;
      var editedItem = {'studentId': student.studentId, 'exams':[]};
      var detailsOfExams = [];
      var sIndexInArray = R.findIndex(R.propEq('studentId', student.studentId))(self.editedItemsArray);
      if(sIndexInArray > -1){
        detailsOfExams = self.editedItemsArray[sIndexInArray].exams;
      }
      else{
        self.editedItemsArray.push(editedItem);
      }
      var currentSIndex = R.findIndex(R.propEq('studentId', student.studentId))(self.editedItemsArray);
      detailsOfExams.push({'examName': exam});
      detailsOfExams = R.uniq(detailsOfExams);
      self.editedItemsArray[currentSIndex].exams = detailsOfExams;
    };

    $scope.doneEditing = function (stuIndex) {
      $scope.editing = ""+stuIndex+"false";
      //dong some background ajax calling for persistence...
      console.log(self.newStudentArray);
    };

    $scope.closeDialog = function() {
      $mdDialog.hide();
    };

    var buildArrayForService = function(array){
      console.log(self.editedItemsArray);
      var addMarks = [];
        for(var i=0; i<self.editedItemsArray.length; i++){
          var selectedIndex = R.findIndex(R.propEq('studentId', self.editedItemsArray[i].studentId))(array);
          var details = {"studentId": self.editedItemsArray[i].studentId, "examDetails":[]};
          for(var j =0; j<self.editedItemsArray[i].exams.length; j++){
            var marks = array[selectedIndex][self.editedItemsArray[i].exams[j].examName];
            details.examDetails.push({"examName": self.editedItemsArray[i].exams[j].examName, "marks": marks});
          }  
          addMarks.push(details);
        }
      return addMarks;
    };

    $scope.saveDialog = function() {
      console.log(self.editedItemsArray);
      if(self.editedItemsArray.length < 0){
        return;
      }
      var classObj = {"updateStatus": "addMarks","classRoomId": self.classRoomId, "subjectId" :self.subjectId, "subjectName": self.subjectName};
      classObj.addMarks = buildArrayForService($scope.studentArray);
      ClassRoomService.updateClassRoom(classObj).then(function(resp){
        self.getClassDetails();
      });
      //console.log($scope.studentArray);
      
      //self.newStudentArray.push({studentName: $scope.student.studentName, emailId: $scope.student.emailId});
      $mdDialog.hide();
    };
  };

  self.addExam = function(){
  	showAddExam();
  };

  self.addStudent = function() {
  	showAddStudent();
  };

  self.addMarks = function() {
    ExamService.getAllExamDetails(self.classRoomId, self.subjectId).then(function(resp){
      self.examsArray = resp.data;
      showAddMarks();
      console.log(self.examsArray);
    });
  };

}



/** WEBPACK FOOTER **
 ** ./src/olr-mainfe-indv-class/IndvClassController.js
 **/